import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoader = defineStore('loader', () => {
  const isLoading = ref(false)
  const isPaginationLoading = ref(false)
  
  function start() {
    isLoading.value = true
  }
  
  function finish() {
    isLoading.value = false
  }
  
  function startPagination() {
    isPaginationLoading.value = true
  }
  
  function finishPagination() {
    isPaginationLoading.value = false
  }
  
  return { 
    isLoading, 
    isPaginationLoading,
    start, 
    finish,
    startPagination,
    finishPagination
  }
})